const tenantId = "0f9e35db-544f-4f60-bdcc-5ea416e6dc70";
const resourceID = "https://data-catalog-frontend-prototype.azurewebsites.net";
// const resourceID = "https://projectbabylon.azure.net";
const clientId = "2c15692f-8cfa-45b1-82d8-b36a4e91bf1d";
export const msalConfig = {
  auth: {
    clientId: "2c15692f-8cfa-45b1-82d8-b36a4e91bf1d",
    //scope:"https://management.azure.com/.default",
    authority: "https://login.microsoftonline.com/" + tenantId,
    // redirectUri: "http://localhost:3000/"//local
    // redirectUri: "https://dataexchange-dev.un.org" //dev
    // redirectUri: "https://data-catalog-frontend-prototype-dev.azurewebsites.net/"
    // redirectUri: "https://data-catalog-frontend-prototype.azurewebsites.net/"
    // redirectUri: "https://dataexchange.un.org" //prod
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  }
};

export const loginRequest = {
  scopes: [resourceID + "/user_impersonation"]
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
  graphMailEndpoint: "https://graph.microsoft.com/v1.0/me/messages"
};
